import { RawDataPoint, RegressionResult } from './types';
import { GenericPoint } from './types';

export function calculateCoreyRegression(
  rawData: RawDataPoint[],
  indicesForRegression: number[],
): RegressionResult {

  const dataForRegression = rawData.filter(point =>
    indicesForRegression.includes(point.key)
  );

  const validPoints: GenericPoint[] = [];
  
  for (const point of dataForRegression) {
    const xVal = point.so; 
    const yVal = point.kro;

    if (xVal > 0 && yVal > 0) {
      validPoints.push({ x: Math.log(xVal), y: Math.log(yVal) });
    }
  }

  if (validPoints.length < 2) {
    throw new Error('At least 2 valid data points are required for regression.');
  }

  const initialSums = {
    N: 0, sumX: 0, sumY: 0, sumX2: 0, sumY2: 0, sumXY: 0,
  };
  
  const sums = validPoints.reduce((acc, point) => {
    const { x, y } = point;
    acc.N += 1;
    acc.sumX += x;
    acc.sumY += y;
    acc.sumX2 += x * x;
    acc.sumY2 += y * y;
    acc.sumXY += x * y;
    return acc;
  }, initialSums);

  const { N, sumX, sumY, sumX2, sumY2, sumXY } = sums;
  const denominator = N * sumX2 - sumX * sumX;
  
  if (denominator === 0) {
    throw new Error('Division by zero. Saturation points do not vary.');
  }

  const A_intercepto = (sumX2 * sumY - sumX * sumXY) / denominator;
  const B_slope = (N * sumXY - sumX * sumY) / denominator;
  
  const r2Numerator = Math.pow(N * sumXY - sumX * sumY, 2);
  const r2Denominator = denominator * (N * sumY2 - sumY * sumY);
  const rSquared = r2Denominator === 0 ? 1.0 : r2Numerator / r2Denominator;

  return {
    a_max_calc: Math.exp(A_intercepto),
    b_exponent: B_slope,
    rSquared,
  };
}